import types from './types';

export const setCompanies = (byId = {}) => ({
    type: types.SET_COMPANIES,
    payload: { byId, ids: Object.keys(byId) },
});
